import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import {
  IconBuilding,
  IconCategory,
  IconSettings,
  IconUsers,
  IconUsersGroup,
} from "@tabler/icons-react";
import AppHeader from "../../components/Header/AppHeader";

const navItems = [
  {
    to: "/system-configuration/team-manager",
    label: "Users",
    icon: IconUsers,
  },
  {
    to: "/system-configuration/agreement-categories",
    label: "Agreement Categories",
    icon: IconCategory,
  },
  {
    to: "/system-configuration/party-list",
    label: "Parties",
    icon: IconUsersGroup,
  },
  {
    to: "/system-configuration/bu-list",
    label: "Business Units",
    icon: IconBuilding,
  },
];

const linkClassName = ({ isActive }) =>
  [
    "group flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm no-underline transition-all duration-150",
    isActive
      ? "bg-sky-500/10 font-semibold text-sky-700 shadow-sm ring-1 ring-sky-500/20"
      : "font-medium text-slate-600 hover:bg-white/80 hover:text-slate-900",
  ].join(" ");

const SCLayout = () => {
  return (
    <div className="flex h-screen flex-col bg-slate-50">
      <AppHeader />
      <div className="flex min-h-0 flex-1">
        <aside className="flex max-w-md shrink-0 flex-col border-r border-slate-200 bg-[#F1F4FA] gap-2 overflow-y-auto p-3">
          {navItems.map(({ to, label, icon: Icon }) => (
            <NavLink key={to} to={to} className={linkClassName}>
              {({ isActive }) => <span className="leading-snug">{label}</span>}
            </NavLink>
          ))}
        </aside>

        <main className="min-w-0 flex-1 overflow-auto bg-white p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default SCLayout;
